import React, { useState } from 'react';
const faqs = [{
  q: '¿Es un curso en video o PDF?',
  a: 'Son Guías Maestras en formato PDF de alta resolución, diseñadas para ser consultadas rápido mientras enseñas.'
}, {
  q: '¿Qué pasa si mis alumnos son muy principiantes?',
  a: 'El sistema cubre desde el Tomo 1 (Básico) con todas las adaptaciones necesarias.'
}, {
  q: '¿Puedo imprimir el material?',
  a: 'Sí, está optimizado para impresión o para uso digital en tablets y móviles.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Acceso inmediato por email tras el pago.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-92">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4 mb-16" data-id="element-93">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(132,204,22,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-94">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-95">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-96">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-97">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-98">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-99">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-100">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cta-green/20 blur-[80px] pointer-events-none rounded-full" aria-hidden="true" data-id="element-101"></div>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-black shadow-[0_0_30px_rgba(132,204,22,0.3)] border border-white/20" data-id="element-102">
            🛒 ¡SÍ! QUIERO EL MEGAPACK POR $19.90 USD
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-103">
            <span data-id="element-104">⚡ Acceso Inmediato</span>
            <span data-id="element-105">•</span>
            <span data-id="element-106">🛡️ Garantía de 7 Días</span>
          </p>
        </div>
      </div>
    </section>;
}